exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inquiry-conditon-btn[data-v-f3cd97c8]{margin-top:1rem;text-align:center;font-size:.4rem;color:#598ffd}", ""]);

// exports
